module.exports = __webpack_public_path__ + "0fddfee917e5e39cc0235ceb727b1472.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/jotto_mobile.png
 ** module id = 272
 ** module chunks = 0
 **/